// extracted by mini-css-extract-plugin
export default {"bodyElement":"BodyElement_bodyElement__JieWi"};